export function constrainXYZ(rotation) {
    const axis = ['x', 'y', 'z'];
    for(let a of axis) {
        if(rotation[a] > Math.PI) {
            rotation[a] = -Math.PI;
        } else if(rotation[a] < -Math.PI) {
            rotation[a] = Math.PI;
        }    
    }
    return rotation;
}

export function constrainArray(rotation) {
    for(let i in rotation) {
        if(rotation[i] > Math.PI) {
            rotation[i] = -Math.PI;
        } else if(rotation[i] < -Math.PI) {
            rotation[i] = Math.PI;
        }    
    }
    return rotation;
}

export function constrainSingle(rotation) {
    if(rotation > Math.PI) {
        return -Math.PI;
    } else if(rotation < -Math.PI) {
        return Math.PI;
    }
}

export function clamp(val, min, max) {
    return val > max ? max : val < min ? min : val;
}